<template>
  <div class="whole">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <div class="userOperate">
        <el-select placeholder="请选择审核状态" v-model="filter.status" style="float: left;">
          <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"/>
        </el-select>
        <el-input v-model="filter.storeName" placeholder="请输入门店名称" style="float: left;"></el-input>
        <el-button @click="_getList" type="primary" style="float: left;">搜索</el-button>
        <el-pagination background layout="prev, pager, next" :current-page="pageNum"
                       @current-change="pageChange"
                       :total="totalNum" v-if="paginationShow"></el-pagination>

      </div>
      <div class="categoryTable">
        <el-table ref="multipleTable" :data="list" tooltip-effect="dark" style="width: 100%" border>
          <el-table-column prop="id" label="序号" width="60"/>
          <el-table-column prop="storeName" label="门店名称" width="160"/>
          <el-table-column prop="" label="账户金额" width="160"/>
          <el-table-column prop="money" label="提现金额" width="160"/>
          <el-table-column prop="" label="账户结余" width="160"/>
          <el-table-column prop="insertTime" label="提现时间" width="160"/>
          <el-table-column prop="type" label="提现方式" width="160">
            <template slot-scope="scope">
              <span>{{ getType(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="提现账户" width="160"/>
          <el-table-column prop="cardNumbers" label="银行卡号" width="160"/>
          <el-table-column prop="openingBank" label="开户行" width="160"/>
          <el-table-column prop="cardUserName" label="账户名称" width="160"/>
          <el-table-column prop="alipayAccount" label="支付宝账号" width="160"/>
          <el-table-column prop="alipayUserName" label="支付宝用户名" width="160"/>
          <el-table-column prop="status" label="状态" width="160">
            <template slot-scope="scope">
              <span>{{ getStatus(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" show-overflow-tooltip  width="160">
            <template slot-scope="scope" >
              <el-button v-if="scope.row.status==0" size="mini" @click="onOption(scope.$index, scope.row,1)">同意</el-button>
              <el-button v-if="scope.row.status==0" size="mini" @click="onOption(scope.$index, scope.row,2)">拒绝</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--      提示弹框-->
      <el-dialog title="提示"
                 :visible.sync="showRejectModal"
                 :append-to-body=true
                 width="40%"
                 :modal=false>
        <el-form label-position="left" label-width="80px">
          <el-form-item label="备注:">
            <el-input v-model="checkRemark"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showRejectModal = false">取 消</el-button>
          <el-button type="primary" @click="onModalOk()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {Loading} from 'element-ui'
import MSidebar from 'components/header/sidebar'
import MHeader from 'components/header/header'
import {getFinanceStore, postFinanceStore} from 'api/request'
import {ERR_OK} from 'api/config'
import {loadingInstance, Error} from 'common/js/util'

export default {
  components: {MSidebar, MHeader},
  data () {
    return {
      status: 1,
      pageSize: 10,
      pageNum: 1,
      totalPage: 0,
      paginationShow: false,
      list: [],
      showRejectModal: false, // 拒绝理由弹框
      checkRemark: null, // 拒绝理由
      editRow: null, // 编辑内容
      filter:{
        storeName:'',
        status:''
      },
      statusList:[
        {value:"",label:'请选择'},{value:"0",label:'待审核'},
        {value:"1",label:'审核通过'},{value:"2",label:'驳回'},
        ]
    }
  },
  mounted () {
    let getUserInfo = JSON.parse(window.localStorage.getItem('getUserInfo'))
    if (!getUserInfo) {
      this.$router.push({
        path: '/'
      })
    } else {
      this._getList()
    }
  },
  methods: {
    getType (row) {
      if(row.type == 1) return "银行卡";
      if(row.type == 2) return "支付宝";
    },
    getStatus (row) {
      if (row.status === 0) return '待审核'
      if (row.status === 1) return '审核通过'
      if (row.status === 2) return '驳回'
    },
    // 点击分页
    pageChange (val) {
      this.pageNum = val
      this.categoryDatas = []
      this._getList()
    },
    onOption(index, row,status){
      this.showRejectModal = true
      this.editRow = row
      this.status = status
    },
    onModalOk(){
      if (!this.checkRemark) {
        this.$message('请填写备注')
        return
      }
      let param = {
        id: this.editRow.id,
        status: this.status,
        checkRemark: this.checkRemark
      }
      loadingInstance(Loading)
      postFinanceStore(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.checkRemark = null
          this.showRejectModal = false
          let text = this.status == '1'?'同意':'拒绝';
          this.$message(text)
          this._getList()
        } else {
          Error(this, res)
        }
      })
    },
    // 获取列表
    _getList () {
      let param = {
        current: this.pageNum,
        size: this.pageSize,
        status:this.filter.status,
        userName:'',
        storeName:this.filter.storeName
      }
      loadingInstance(Loading)
      getFinanceStore(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.list = res.data.records
          this.totalNum = res.data.total
          if (res.data.pages > 1) {
            this.paginationShow = true
          }
        } else {
          Error(this, res)
        }
      })
    }
  }
}
</script>
<style scoped>
  .userOperate{
    height: 50px;
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 30px;
    margin-bottom: 10px;
    box-sizing: border-box;
  }

.userOperate .el-input {
    width:180px;
    margin-right: 10px;
    display: inline-block;
    float: left;
  }
  .userOperate .el-button {
    width:100px;
    display: inline-block;
    float: left;
    margin-right: 40px;
  }

.categoryOperate {
  height: 40px;
  margin: 20px;
  box-sizing: border-box;
}

.categoryTable {
  padding-left: 20px;
  padding-right: 20px;
  position: relative;
}
</style>
<style>
.el-tag + .el-tag {
  margin: 5px;
}

.categoryOperate .el-input {
  width: 180px;
  height: 40px;
  margin-right: 10px;
  display: inline-block;
  float: left;
}

.categoryOperate .el-button {
  width: 100px;
  height: 40px;
  display: inline-block;
  float: left;
  margin-right: 40px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/finance/store.vue